import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import ResultSection from "./ResultSection";

const MessageList = ({ messages }) => {
  return (
    <Box sx={{ p: 1.5, height: "100%", overflowY: "auto" }}>
      {messages.map((msg) => {
        const isUser = msg.SenderType === "USER";
        const payload = msg.MessageJson;

        return (
          <Box
            key={msg.MessageId}
            sx={{
              display: "flex",
              justifyContent: isUser ? "flex-end" : "flex-start",
              mb: 1.5,
            }}
          >
            <Paper
              sx={{
                p: 1.2,
                maxWidth: "90%",
                borderRadius: 2,
                bgcolor: isUser ? "#F07828" : "#fff",
                color: isUser ? "#fff" : "#222",
              }}
            >
              <Typography variant="body2">{msg.MessageText}</Typography>

              {!isUser && payload?.sections?.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  {payload.sections.map((section, idx) => (
                    <ResultSection key={idx} section={section} />
                  ))}
                </Box>
              )}
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
};

export default MessageList;